<template>
  <div id="scrollArea" ref="scrollArea" class="search-list">
    <div class="search-list__filter-category-container">
      <div v-for="category in categoryList" :key="category">
        <button
          type="button"
          class="search-list__filter-category"
          :class="{
            'is-active': activeCategory === category,
            'sanitastab':
              category.substring(2, category.length) === 'uebersanitas',
          }"
          @click="categoryFilterThis(category)"
        >
          <DotcomIcon
            v-if="
              category !== categoryList[0] &&
              category.substring(2, category.length) !== 'uebersanitas'
            "
            :name="categoryIconName(category)"
            art="light"
            class="search-list__filter-category-icon"
          />
          <span
            v-if="category.substring(2, category.length) === 'uebersanitas'"
            class="search-list__filter-category-icon-svg-span"
          >
            <svg
              class="search-list__filter-category-icon-svg"
              width="14px"
              height="17px"
              viewBox="0 0 14 17"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Search"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="EP_COM_Search_Desk_No-Results-Copy"
                  transform="translate(-622.000000, -263.000000)"
                  stroke="#191919"
                >
                  <path
                    id="S"
                    stroke="currentColor"
                    d="M631.237083,270.21421 L629.532959,269.595827 C628.349084,269.163837 627.634462,268.917612 627.634462,268.23877 C627.634462,267.662991 628.139316,267.373849 629.087763,267.373849 C630.374917,267.373849 632.289772,267.765428 633.42778,268.011027 L633.995821,264.742121 C632.733685,264.453919 630.562875,264 628.331123,264 C625.317071,264 623,265.665936 623,268.609987 C623,270.996116 624.389793,272.004198 626.832596,272.866926 L628.28718,273.383184 C629.594221,273.854019 629.973664,274.019109 629.973664,274.655347 C629.973664,275.438193 629.045745,275.542823 628.245804,275.542823 C626.856332,275.542823 624.936986,275.10958 623.778772,274.925381 L623.14594,278.339954 C624.430849,278.628156 626.728675,279 628.666944,279 C632.627839,279 634.647898,277.29146 634.647898,274.596767 C634.647898,272.908903 634.01667,271.221665 631.237083,270.21421"
                  ></path>
                </g>
              </g>
            </svg>
          </span>

          {{ niceCategoryList[category] }}&emsp;
          <span
            v-if="listsByCategory[category] != undefined"
            class="section-counter"
          >
            {{ listsByCategory[category].length }}
          </span>
        </button>
      </div>
    </div>

    <div class="all-results">
      <div v-for="category in categoryList" :key="category">
        <div v-show="category === activeCategory">
          <div
            v-for="result in shortListsByCategory(category)"
            :key="showCounter + '-re-' + result.url"
          >
            <SanitasSearchResult
              type="articles"
              :href="result.url"
              :title="result.title"
              :description="result.description"
              :category="result.category"
              :breadcrumbdata="result.breadcrumbdata"
            />
          </div>
          <div
            v-if="showMoreButton"
            id="search-list__show-more-button-container"
            ref="search-list__show-more-button-container"
            class="search-list__show-more-button-container"
          >
            <SanitasButton
              v-if="isShowMoreButton(category)"
              class="search-list__show-more-button"
              @click="showMore"
            >
              {{ $t('search-show-more') }}
            </SanitasButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import SanitasButton from '@/components/sanitas-components/SanitasButton'
import DotcomIcon from '@/modules/icon/Icon'

import SanitasSearchResult from './SanitasSearchResult'

export default {
  name: 'SanitasSearchList',
  components: {
    SanitasSearchResult,
    DotcomIcon,
    SanitasButton,
  },
  props: {
    results: {
      type: Object,
      default: () => ({}),
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
    niceCategoryList: {
      type: Object,
      default: () => {},
    },
    listsByCategory: {
      type: Object,
      default: () => ({}),
    },
    lastActiveCategory: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },
  data: () => ({
    activeTab: 0,
    activeCategory: '',
    showCounter: 10,
    showMoreButton: true,
  }),
  computed: {},

  mounted() {
    if (this.categoryList.includes(this.lastActiveCategory)) {
      this.activeCategory = this.lastActiveCategory
    } else {
      this.activeCategory = this.categoryList[0]
    }
    this.$emit('sanitassearchsetlastcategory', this.activeCategory)
  },

  methods: {
    categoryFilterThis: function (category) {
      this.activeCategory = category
      this.$emit('sanitassearchsetlastcategory', category)
    },
    shortListsByCategory: function (category) {
      return this.listsByCategory[category].slice(0, this.showCounter)
    },
    categoryIconName: function (langcategory) {
      let category = langcategory.substring(2, langcategory.length)
      if (category === 'all') return ''
      if (category === 'privatkunden') return 'house'
      if (category === 'uebersanitas') return 's'
      if (category === 'magazin') return 'book-open'
      if (category === 'healthforecast') return 'book'
      return ''
    },
    showMore: function () {
      this.showMoreButton = false
      this.$nextTick(() => {
        this.showCounter += 10
      })
      this.$nextTick(() => {
        this.showMoreButton = true
      })
    },
    isShowMoreButton: function (category) {
      return this.showCounter < this.listsByCategory[category].length
    },
  },
}
</script>

<style lang="postcss" scoped>
.search-list {
  opacity: 1;
  transition: opacity 0.3s;
}

.search-list__filter-category {
  background: none;
  border: none;
  cursor: pointer;
  background-color: var(--c-secondary-neutral-3);
  color: var(--c-primary-neutral-1);
  border-radius: 25px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  padding: var(--spacing-2) var(--spacing-4);
  position: relative;
  white-space: nowrap;

  &.sanitastab {
    padding-left: 42px;
  }

  &:hover {
    cursor: pointer;
    color: var(--c-primary-neutral-3);
    background-color: var(--c-primary-color-2);
  }

  &.is-active {
    background-color: var(--c-primary-color-2);
    color: var(--c-primary-neutral-3);
    font-weight: 400;
  }
}
.search-list__filter-category-icon {
  margin-right: var(--spacing-2);
}
.search-list__filter-category-container {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--spacing-2) var(--spacing-4);
  overflow-x: auto;
  padding-bottom: var(--spacing-8);
}

.search-list__show-more-button-container {
  display: flex;
  justify-content: center;
  margin: 32px 0;
}
.search-list__filter-category-icon-svg-span {
  display: block;
  position: absolute;
  width: 14px;
  height: 19px;
  top: 50%;
  left: 17px;
  transform: translateY(-50%);
}
.search-list__filter-category-icon-svg {
  width: 100%;
  height: 100%;
  button:hover & {
    color: var(--c-primary-neutral-3);
  }
}

@media (--xs) {
  .search-list__filter-category-container {
    flex-wrap: wrap;
    overflow-x: unset;
    white-space: unset;
    padding-bottom: 0;
    margin-bottom: var(--spacing-8);
  }
}
</style>

